import { render, staticRenderFns } from "./PurchaseImagePlan.vue?vue&type=template&id=5eddb3ed"
import script from "./PurchaseImagePlan.vue?vue&type=script&lang=js"
export * from "./PurchaseImagePlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports